<template>
	<nav class="navbar navbar-expand-lg navbar-light justify-content-start w-100 p-0 m-0" :class="{ 'main-nav' : main.isavailable }">
		<div class="container-fluid">
			<!-- <a class="navbar-brand" href="/" style="width:80px;"><img src="@/assets/img/techtitanslogo.jpeg" class="img-fluid"></a> -->
			<a class="navbar-brand" href="/" style="width:139px;min-width:139px"><img src="@/assets/img/t-tech-green.svg" alt="Tech Titans" class="img-fluid"></a>
			<!--div class="position-absolutep-1" style="width:34px;top:10px;left:200px;"><img src="@/assets/beta.svg" class="img-fluid"></div-->
			<button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="w-100">
				<slot name="search"></slot>
			</div>
			<div class="collapse navbar-collapse" id="navbarSupportedContent">
				<ul class="ms-auto navbar-nav mb-2 mb-lg-0 text-start">
					<li class="nav-item">
						<TopNavBarGame />
					</li>
					<li class="nav-item" :class="{ 'fw-semibold' : main.isavailable }">
						<router-link @click="$scrollToTop" to="/" aria-current="page" class="nav-link active">{{ $t('menu.home', 'Home') }}</router-link>
					</li>
					<!-- <li class="nav-item dropdown animatedmenu" :class="{ 'fw-semibold' : main.isavailable }">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownLearning" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							{{ $t('menu.solutions', 'Solutions') }}
						</a>
						<ul class="dropdown-menu mainm solutions" :class="{  'homepage-user-menu' : main.isavailable }" aria-labelledby="navbarDropdownLearning">
							<div class="dropdown-menu-inner">
								<div class="dropdown-inner-area">
									<div class="dropdown-title">{{ $t('menu.forcompanies', 'For Companies') }}</div>
									<div class="dropdown-link-area">
										<router-link @click="$scrollToTop" to="/l/recruiting" aria-current="page" class="dropdown-link">{{ $t('menu.recruiting', 'Recruiting') }}</router-link>
										<router-link @click="$scrollToTop" to="/l/learning" aria-current="page" class="dropdown-link">{{ $t('menu.learning', 'Learning') }}</router-link>
									</div>
								</div>
							</div>
							<div class="dropdown-menu-inner">
								<div class="dropdown-inner-area">
									<div class="dropdown-title">{{ $t('menu.forcolleges', 'For Colleges') }}</div>
									<div class="dropdown-link-area">
										<router-link @click="$scrollToTop" to="/t/colleges" aria-current="page" class="dropdown-link">{{ $t('menu.schools', 'College Learning') }}</router-link>
									</div>
								</div>
							</div>
						</ul>
					</li> -->
					<li class="nav-item dropdown animatedmenu" :class="{ 'fw-semibold' : main.isavailable }">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownLearning" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							{{ $t('menu.learning', 'Learning') }}
						</a>
						<ul class="dropdown-menu mainm learning dropdown-menu-end" :class="{  'homepage-user-menu' : main.isavailable }" aria-labelledby="navbarDropdownLearning">
							<div class="dropdown-menu-inner">
								<div class="dropdown-inner-area">
									<div class="dropdown-title">{{ $t('menu.subscriptions13up', 'All courses, one subscription — from age 13 and up') }}</div>
									<div class="dropdown-link-area mobfx">
										<router-link @click="$scrollToTop" to="/l/learning" aria-current="page" class="dropdown-link tt-dropdown-item">{{ $t('menu.explorecourses', 'Explore Courses') }}</router-link>
										<router-link @click="$scrollToTop" to="/members/subscriptions" aria-current="page" class="dropdown-link tt-dropdown-item">{{ $t('menu.subscriptions', 'Subscriptions') }}</router-link>
										<router-link @click="$scrollToTop" to="/t/colleges" aria-current="page" class="dropdown-link tt-dropdown-item">{{ $t('menu.schools', 'College Subscriptions') }}</router-link>
										<router-link @click="$scrollToTop" to="/learners" aria-current="page" class="dropdown-link tt-dropdown-item">{{ $t('menu.learners', 'Learners') }}</router-link>
									</div>
								</div>
								<div class="dropdown-main">
									<div class="dropdown-main-group">
										<li>
											<router-link @click="$scrollToTop" to="/s/gamedesign" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-dpad"></i> Game Design</router-link>
										</li>
										<li>
											<router-link @click="$scrollToTop" to="/s/animation" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-box"></i> Animation</router-link>
										</li>
										<li>
											<router-link @click="$scrollToTop" to="/s/sounddesign" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-soundwave"></i> Sound Design</router-link>
										</li>
									</div>
									<div class="dropdown-main-group">
										<li>
											<router-link @click="$scrollToTop" to="/s/webdevelopment" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-cpu"></i> Web Development</router-link>
										</li>
										<li>
											<router-link @click="$scrollToTop" to="/s/graphics" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-palette"></i> Graphic/UI/UX Design</router-link>
										</li>
										<li>
											<router-link @click="$scrollToTop" to="/s/digitalart" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-box2-heart"></i> Digital Art</router-link>
										</li>
									</div>
									<div class="dropdown-main-group">
										<li>
											<router-link @click="$scrollToTop" to="/s/marketing" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-bar-chart"></i> Digital Marketing</router-link>
										</li>
										<li>
											<router-link @click="$scrollToTop" to="/s/computerliteracy" aria-current="page" class="dropdown-item tt-dropdown-item"><i class="bi bi-laptop"></i> Computer Literacy</router-link>
										</li>
									</div>
								</div>
							</div>
						</ul>
					</li>
					<li class="nav-item dropdown animatedmenu" :class="{ 'fw-semibold' : main.isavailable }">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownLearning" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							{{ $t('menu.recruitment', 'Recruitment') }}
						</a>
						<ul class="dropdown-menu mainm recruitment" :class="{  'homepage-user-menu' : main.isavailable }" aria-labelledby="navbarDropdownLearning">
							<div class="dropdown-menu-inner">
								<div class="dropdown-inner-area">
									<div class="dropdown-title">{{ $t('menu.forcompanies', 'For Companies') }}</div>
									<div class="dropdown-link-area">
										<router-link @click="$scrollToTop" to="/l/recruiting" aria-current="page" class="dropdown-link tt-dropdown-item">{{ $t('menu.recruitmentups', 'Recruitement & Upskilling') }}</router-link>
									</div>
								</div>
								<div class="dropdown-main">
									<div class="dropdown-main-group">
										<li>
											<router-link @click="$scrollToTop" to="/r/job" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.postajob', 'Post a Job') }}</router-link>
										</li>
										<li>
											<router-link @click="$scrollToTop" to="/r/joblistings" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.findajob', 'Find a Job') }}</router-link>
										</li>
									</div>
								</div>
							</div>
						</ul>
					</li>
					<li class="nav-item dropdown animatedmenu" :class="{ 'fw-semibold' : main.isavailable }">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownLearning" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							{{ $t('menu.collegeadtech', 'College AdTech') }}
						</a>
						<ul class="dropdown-menu mainm collegeadtech" :class="{  'homepage-user-menu' : main.isavailable }" aria-labelledby="navbarDropdownLearning">
							<div class="dropdown-menu-inner">
								<div class="dropdown-inner-area">
									<div class="dropdown-title">{{ $t('menu.forcolleges', 'For Colleges') }}</div>
									<div class="dropdown-link-area">
										<router-link @click="$scrollToTop" to="/t/colleges" aria-current="page" class="dropdown-link tt-dropdown-item">{{ $t('menu.schools', 'College Learning') }}</router-link>
									</div>
								</div>
							</div>
						</ul>
					</li>
					<li class="nav-item dropdown animatedmenu" :class="{ 'fw-semibold' : main.isavailable }">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownLearning" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							{{ $t('menu.about', 'About') }}
						</a>
						<ul class="dropdown-menu mainm" :class="{  'homepage-user-menu' : main.isavailable }" aria-labelledby="navbarSupportedContent">
							<li>
								<router-link @click="$scrollToTop" to="/t/about" aria-current="page" data-toggle="collapse" class="dropdown-item tt-dropdown-item">{{ $t('menu.aboutus', 'About Us') }}</router-link>
							</li>
							<li>
								<router-link @click="$scrollToTop" to="/t/contact" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.contact', 'Contact') }}</router-link>
							</li>
							<li>
								<router-link @click="$scrollToTop" to="/t/colleges" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.schools', 'College Subscriptions') }}</router-link>
							</li>
							<li>
								<router-link @click="$scrollToTop" to="/members/subscriptions" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.subscriptions', 'Subscriptions') }}</router-link>
							</li>
						</ul>
					</li>
					<span v-if="loggedin" class="d-lg-none">
						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownAccount" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								{{ $t('menu.myaccount', 'My Account') }}
							</a>
							<ul @click="umenu.refresh=!umenu.refresh" :class="{  'homepage-user-menu' : main.isavailable }" class="dropdown-menu" aria-labelledby="navbarDropdownAccount">
								<!-- <li>
									<router-link @click="$scrollToTop" to="/u/my/gamedashboard" aria-current="page" class="dropdown-item tt-dropdown-item">Game Dashboard</router-link>
								</li> -->
								<li v-if="iscompany">
									<router-link @click="$scrollToTop" to="/u/my/company" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.mycompany', 'My Company') }}</router-link>
								</li>
								<li v-if="isteacher">
									<router-link @click="$scrollToTop" to="/u/tr/dashboard" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.teacherdashboard', 'Teacher Dashboard') }}</router-link>
								</li>
								<li v-if="!iscompany">
									<router-link @click="$scrollToTop" to="/u/my/dashboard" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.mydashboard', 'My Dashboard') }}</router-link>
								</li>
								<li v-if="!school">
									<router-link @click="$scrollToTop" to="/u/my/account" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.myaccount', 'My Account') }}</router-link>
								</li>
								<li>
									<hr class="dropdown-divider">
								</li>
								<li>
									<a role='button' @click="logOut" class="dropdown-item tt-dropdown-item">{{ $t('menu.signout', 'Log Out') }}</a>
								</li>
							</ul>
						</li>
					</span>
					<span v-if="!loggedin" class="d-lg-none mb-2 me-4" style="padding-left: 16px;"><a href="/login"><button type="button" class="tt-dropdown-item btn p-0 m-0 btn-sm bg-transparent btn-light border-0 text-nowrap">Log In</button></a></span>
					<LanguageSelector class="me-4 d-lg-none" style="margin-left: 10px;" />
				</ul>
			</div>
		</div>
	</nav>
</template>
<script lang="ts" setup>
import { onBeforeMount } from 'vue';
import axios from 'axios';
// import TopLabel from "@/components/elements/TopLabel.vue";
import TopNavBarGame from '@/components/TopNavbarGame.vue';
import LanguageSelector from '@/components/elements/LanguageSelector.vue';
import { getCookie, cleanUser, generateRandomAlphaNum } from "@/common/common.js";
import { userMenuStore } from '@/store/userMenuStore';
import { userMainStore } from '@/store/userMainStore';

const main = userMainStore();
const umenu = userMenuStore();
let token = localStorage.getItem("token");
let school = localStorage.getItem("school");
let iscompany = localStorage.getItem("iscompany");
// let isstudent = localStorage.getItem("isstudent");
let isteacher = localStorage.getItem("isteacher");

let loggedin = false;

onBeforeMount(
	async () => {
		if (getCookie("uid")) {
			loggedin = true;
		}
	});


const logOut = async () => {
	await axios
		.get('/api/v1/logout', {
			headers: { Authorization: `${token}` },
			withCredentials: true
		})
		.then(() => {
			cleanUser();
			document.location = "/login?" + generateRandomAlphaNum(5);
		});
}
</script>
<style scoped lang="scss">
#app nav>.nav-link {
	font-weight: 600;
	border-radius: 0;
	border-bottom: 1px solid transparent;
}

nav .dropdown-item {
	margin: 6px auto;

	@media (min-width: 992px) {
		--bs-dropdown-item-padding-x: 0px;
	}
}

.navbar-brand:hover,
.navbar-brand:focus {
	border-bottom: none;
}

#app nav a.router-link-active.router-link-exact-active.nav-link,
#app nav .nav-link.dropdown-toggle.show {
	border-radius: 0;
}

.dropdown-title {
	color: var(--Off-black-80, #454545);

	@media (max-width: 992px) {
		color: var(---tt-off-white, #f5f5f5);
	}

	text-align: center;
	font-family: Roboto;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
	text-transform: uppercase;
}

.dropdown-link-area {
	display: flex;
	align-items: center;
	gap: 40px;
}

@media (max-width: 576px) {
	.dropdown-link-area.mobfx {
		display: block;
	}

	.dropdown-link-area.mobfx a {
		display: block;
		text-align: left;
		margin: 12px 0;
	}
}

.dropdown-link-area.mobfx {
	text-wrap: nowrap;
}

.dropdown-main {
	display: flex;
	align-items: flex-start;
	gap: 40px;

	@media (max-width: 992px) {
		flex-wrap: wrap;
		gap: 0px;
	}
}

.dropdown-link {
	color: var(--Off-black-100, #161616);

	@media (max-width: 992px) {
		color: var(---tt-off-white, #f5f5f5);
	}

	text-align: center;
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.5px;
}

.dropdown-item {
	color: var(--Off-black-100, #161616);
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.5px;
}

.dropdown-inner-area {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
}

#app .nav-link.dropdown-toggle.show {
	xbackground-color: var(--tt-1);
}

#app .nav-link {
	border-bottom: 1px solid transparent;
	border-left: 1px solid transparent;
	border-right: 1px solid transparent;
}

#app .nav-link:hover {
	border-bottom: 1px solid var(--tt-1) !important;
}

#app nav .dropdown-menu a:hover {
	border-bottom: none !important;
}

.dropdown-menu.mainm {
	--bs-dropdown-border-color: #f1f1f1;

	@media (min-width: 992px) {
		display: flex;
	}

	padding: 20px 40px 20px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 28px;
	border-radius: 8px;
	background: var(--Background-White, #FFFFFE);
	box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30),
	0px 1px 3px 1px rgba(0, 0, 0, 0.15);
}

.dropdown-menu.learning {}

.dropdown-menu.learning .bi {
	color: var(--tt-1);
	font-size: 20px;
	-webkit-text-stroke: .5px;
}


.dropdown-menu-inner {
	width: 100%;
	display: flex;
	padding: 20px 40px 20px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 28px;
}

.nav-item {
	color: var(--Off-black-100, #161616);
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.5px;
}

.nav-item.dropdown .dropdown-item {
	x-color: var(--tt-1);
}

.dropdown-item:hover,
.dropdown-item:focus {
	color: rgba(var(--tt-1-rgb), 1);
	background-color: transparent;
}

.dropdown-link:hover,
.dropdown-link:focus {
	color: rgba(var(--tt-1-rgb), 1);
	background-color: transparent;
}

/*
nav .dropdown-menu a.router-link-exact-active:hover {
	background-color: #000;
}
*/

nav .dropdown-menu a.router-link-exact-active {
	background-color: transparent;
	color: var(--tt-1);
}

.mainm.recruitment {
	min-width: 400px;
}

.mainm.collegeadtech {
	min-width: 300px;
}
</style>